import { FC } from 'react'
import styles from 'components/features/pfm/CreditCardIcon/CreditCardIcon.styl'
import SvgIcon from 'components/atoms/SvgIcon'

type CreditCardIconProps = {
  brand: string
  className?: string
}

export const CreditCardIcon: FC<CreditCardIconProps> = (props) => {
  const { brand } = props

  const iconSource = require(`icons/payment-brand/${ brand }.svg?skip-svgo`).default

  return (
    <SvgIcon
      className={ styles.creditCardIcon }
      src={ iconSource }
      useDefaultViewBox
    />
  )
}
